import { Dispatch, SetStateAction, createContext } from 'react';

export enum EventDetailsTab {
  PARTICIPANTS = 'participants',
  WAITLIST = 'waitlist',
}

export interface EventDetailsModalData {
  eventId: number | null;
  initialTab?: EventDetailsTab;
}

export interface EventDetailsModalContextProps {
  eventDetailsModalData: EventDetailsModalData;
  setEventDetailsModalData: Dispatch<SetStateAction<EventDetailsModalData>>;
}

export const EventDetailsModalContext = createContext<EventDetailsModalContextProps>(
  {} as EventDetailsModalContextProps
);
